<template>
  <section class="text-white py-11 px-6">
    <div class="max-w-6xl mx-auto text-center">
      <h1 class="text-4xl lg:text-7xl font-bold text-[#e4ac3b] uppercase drop-shadow-[2px_2px_5px_rgba(228,172,59,0.7)]">
        Products
      </h1>
      <div class="w-80 h-px border border-[#e4ac3b] mx-auto mt-2 drop-shadow-[2px_2px_5px_rgba(228,172,59,0.7)]"></div>
    </div>

    <div class="max-w-6xl mx-auto mt-8 space-y-8">
      <article class="product-card grid md:grid-cols-2 gap-8 items-center p-6 rounded-lg shadow-lg min-h-[24rem]">
        <div class="flex justify-center">
          <img src="../assets/images/ebooks.webp" alt="Wisdom eBooks Club - Digital Library and Study Bible Software" class="product-image">
        </div>
        <div class="flex flex-col justify-center">
          <h2 class="text-5xl font-bold text-gold">Wisdom eBooks Club</h2>
          <p class="text-gray-300 mt-4">
            Access our extensive wisdom eBook library and eStudy Bible software. Join us today and carry your faith in your pocket wherever you go.
          </p>
          <a href="https://wisdomebooksclub.com" target="_blank" rel="noopener noreferrer" class="mt-6 glow-button" aria-label="Visit Wisdom eBooks Club website">
            Visit Site
          </a>
        </div>
      </article>

      <article class="product-card grid md:grid-cols-2 gap-8 items-center p-6 rounded-lg shadow-lg min-h-[24rem]">
        <div class="order-2 md:order-1 flex flex-col justify-center">
          <h2 class="text-5xl font-bold text-gold">EXODUS</h2>
          <p class="text-gray-300 mt-4">
            EXODUS is on its way! A powerful platform dedicated to empowering and uplifting the community through faith, knowledge, and connection.
          </p>
          <button class="mt-6 glow-button disabled" disabled>Coming Soon...</button>
        </div>
        <div class="order-1 md:order-2 flex justify-center">
          <img src="../assets/images/exodus.webp" alt="EXODUS Platform - Faith and Community Empowerment" class="product-image">
        </div>
      </article>
    </div>
  </section>
</template>

<style scoped>
.text-gold {
  color: #C0954D;
}

.product-card {
  background-color: #131313;
  transition: all 0.3s ease-in-out;
}

.product-card:hover {
  box-shadow: 0 0 20px rgba(228, 125, 57, 0.8);
  transform: scale(1.05);
}

.product-image {
  max-height: 250px;
  object-fit: contain;
  transition: all 0.3s ease-in-out;
}

.product-card:hover .product-image {
  filter: drop-shadow(0 0 10px #e4ac3b);
}

.glow-button {
  background-color: #C0954D;
  color: black;
  padding: 10px 20px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  text-align: center;
  display: inline-block;
  width: 170px;
}

.glow-button:hover {
  box-shadow: 0 0 15px rgba(192, 149, 77, 0.8);
  transform: scale(1.05);
}

.glow-button:active {
  transform: scale(0.95);
  box-shadow: 0 0 5px rgba(192, 149, 77, 0.6);
  background-color: #b08a44;
}

.disabled {
  background-color: #555;
  cursor: not-allowed;
  box-shadow: none;
}
</style>
